import Modal from "../../../components/global/Modal";
import useCountdown from "../../../hooks/useCountDown";
import useForceLogout from "../../../hooks/useForceLogout";

const ForceLogoutModal = () => {
  const { forceLogout, handleLogout, handleContinue, warningDuration } = useForceLogout();

  const { timeLeft } = useCountdown({
    durationInMs: warningDuration,
    start: forceLogout,
  });

  return (
    <Modal
      title="Inactive session"
      subtitle="Your session is about to expire due to inactivity"
      open={forceLogout}
      maxWidth="xs"
      closable={false}
      actionsClassName="!flex !flex-row !flex-nowrap !justify-between !gap-4"
      actions={[
        {
          onClick: () => handleLogout(),
          label: "Log Out",
          className: "!border border-blue-600 text-blue-600 bg-white hover:bg-blue-100 w-fit",
        },
        {
          onClick: () => handleContinue(),
          label: "Continue session",
          className:
            "bg-blue-600 text-white hover:bg-blue-700 disabled:text-white disabled:bg-blue-400  w-fit",
        },
      ]}
    >
      <div className="flex w-full items-end justify-center gap-4">
        <span className="text-3xl">{timeLeft}</span> <span>minute(s) left</span>
      </div>
    </Modal>
  );
};

export default ForceLogoutModal;
